<template>
    <div class="download-closely" v-show="showCloselyApp">
        <p class="code-title" v-if="useModule !== 'md-header'">{{ $t('common:closelyDownload.getMyApp') }}</p>
        <div class="code-wrapper" v-if="!isMobileSize">
            <template v-if="useCloselyConfig">
                <div class="ios">
                    <div>
                        <site-img
                            :src="useCloselyConfig.ios.qrCode"
                            alt="Download for iOS"
                            :size="100"
                        />
                    </div>
                    <span>iOS</span>
                </div>
                <div class="android">
                    <div>
                        <site-img
                            :src="useCloselyConfig.android.qrCode"    
                            alt="Download for Android"
                            :size="100"
                        />
                    </div>
                    <span>Android</span>
                </div>
            </template>
            <canvas v-else :ref="toRef" class="qr-code"></canvas>
        </div>
        <p class="code-title down" v-if="useModule === 'md-header' && !isMobileSize">{{ $t('common:closelyDownload.getMyApp') }}</p>
        <div class="download-link" :class="{'closely-config': useCloselyConfig}" v-if="isMobileSize">
            <template v-if="useCloselyConfig">
                <a
                    class="closely-download"
                    aria-label="download closely app"
                    :href="iosOpenLink"
                >
                    <site-img class="ios-download" alt="download" :src="configImgSrc.ios" :size="40" dir="height" />
                </a>
                <a
                    class="closely-download"
                    aria-label="download closely app"
                    :href="androidOpenLink"
                >
                    <site-img
                        class="android-download"
                        alt="download"
                        :src="configImgSrc.android" 
                        :size="40" 
                        dir="height"
                    />
                </a>
            </template>
            <a
                v-else-if="closelyDownloadLink"
                class="closely-download"
                aria-label="download closely app"
                :href="closelyDownloadLink"
            >
                <site-img class="ios-download" alt="download" :src="imgsrc" :size="40" dir="height" />
            </a>
        </div>
    </div>
</template>
<script>

import { mapState, mapActions as rootMapActions } from 'pinia';
import { usePageStore, useUserStore } from '@/store';
import QRCode from 'qrcode';
import { createDownloadPlugin, destroyDownloadPlugin } from "./pop"
export default {
    name: 'closelyAppDownload',
    props: ['downloadTheme', 'useModule'],
    i18next: {
        ns: 'common'
    },
    data: function() {
        return {
            qr: null,
            link: '',
        }
    },
    watch: {
        isMobileSize(val) {
            if (val && !window.installCloselyPlugin) {
                createDownloadPlugin()
            } else if (!val && window.installCloselyPlugin) {
                destroyDownloadPlugin()
            }
        },
        user: {
            deep: true,
            handler: function() {
                this.fetchUseCloselyApp()
            }
        }
    },
    computed: {
        ...mapState(usePageStore, {
            page: store => store.page,
            closelyDownloadLink: store => store.page.closelyDownloadLink,
            mlsForClosely: store => store.mlsForClosely
        }),
        ...mapState(useUserStore, {
            user: store => store.user,
            useCloselyApp: store => store.useCloselyApp,
        }),
        agentId({ page }) {
            return page.agentCreator?.agentId || ''
        },
        isMobileSize({ platform }) {
            return platform.isMobile
        },
        closelyConfig({ page }) {
            return page['closely-app'] || {}
        },
        imgsrc({ downloadTheme }) {
            // return  downloadTheme ? 'https://cdn.chime.me/image/fs/sitebuild/2023911/0/original_8386f352-41a4-4385-93f6-fd22ba913d68.png' : 'https://cdn.chime.me/image/fs/sitebuild/2023911/0/original_5e7122c1-b0ee-4bd7-b140-308a1e596685.png'
            return 'https://cdn.chime.me/image/fs/sitebuild/2024619/10/original_e777b5d6-4706-4fb0-95da-9934a5ee3fc6.jpg';
        },
        configImgSrc({ downloadTheme }) {
            if (!downloadTheme) {
                return {
                    ios: 'https://cdn.chime.me/image/fs/sitebuild/20221221/23/original_13be94c8-393b-4c30-b642-0d3f9e716c24.png',
                    android:
                        'https://cdn.chime.me/image/fs/sitebuild/20221221/23/original_469e5a18-78d6-4088-8e20-3c03d8719e90.png'
                };
            }
            return {
                ios: 'https://cdn.chime.me/image/fs/sitebuild/20221225/22/original_62c035b8-59f1-41b2-988d-9aa37784c1e0.png',
                android:
                    'https://cdn.chime.me/image/fs/sitebuild/20221225/22/original_33ff7bb1-69e0-4cc9-8a18-5dfda98d8ef3.png'
            };
        },
        useCloselyConfig({ useModule, closelyConfig }) {
            let customerConfig = closelyConfig?.customer;
            if (
                customerConfig &&
                customerConfig?.useModule?.includes?.(useModule)
            ) {
                if (!customerConfig.isControlForClosely) {
                    return customerConfig;
                } else {
                    return (
                        closelyConfig?.openCloselyLink &&
                        customerConfig
                    );
                }
            }
            return false;
            
        },
        iosOpenLink({ useCloselyConfig }) {
            return !this.platform.isAndroid
                ? useCloselyConfig?.ios?.openStore
                : useCloselyConfig?.ios?.downloadLink;
        },
        androidOpenLink({ useCloselyConfig }) {
            return this.platform.isAndroid
                ? useCloselyConfig?.android?.openStore
                : useCloselyConfig?.android?.downloadLink;
        },
        showCloselyApp({ useModule, mlsForClosely, useCloselyApp }) {
            if (useModule === 'md-header') {
                return !useCloselyApp && mlsForClosely
            }
            return mlsForClosely
        }
    },
    mounted() {
        this.fetchUseCloselyApp()
        if (this.closelyConfig['openCloselyLink'] ?? true) {
            this.generateQrCode();
        }   
    },
    methods: {
        toRef(e) {
            this.qr =  e;
            this.generateQrCode();
        },
        generateQrCode() {
            if (this.qr && this.closelyDownloadLink) {
                QRCode.toCanvas(this.qr, this.closelyDownloadLink, {
                    width: 100,
                    margin: 0
                })
            }
        },
        ...rootMapActions(useUserStore, {
            fetchUseCloselyApp: 'fetchUseCloselyApp',
        })
    }
};

</script>
<style lang="scss">
.download-closely {
    cursor: default;
    .code-title {
        color: #fff;
        font-size: 14px;
        line-height: 20px;
        font-family: var(--font-normal);
        margin-bottom: 15px;
        &.down{
            color:#191919;
            margin-top: 15px;
            margin-bottom: 0px;
            text-align: center;
        }
    }

    .code-wrapper {
        display: flex;
        text-align: center;
        justify-content: center;
        .ios,
        .android {
            img {
                width: 100px;
                height: 100px;
                vertical-align: bottom;
            }

            &.android {
                margin-left: 20px;
            }

            span {
                margin-top: 10px;
                font-size: 14px;
                line-height: 12px;
                color: #a0a3af;
                font-family: var(--font-normal);
                display: inline-block;
            }
        }
        .qr-code{
            border: 3px solid #fff;
            border-radius: 5px;
        }
    }

    .download-link {
        &.closely-config{
            display: flex;
            .closely-download{
                display: block;
                margin-left: 20px;
                &:first-of-type{
                    margin-left: 0px;
                }
            }
        }
        .closely-download{
            display: inline-flex;
        }
        img {
            height: 40px;
        }
    }
}

.intall-closely-plugin {
    height: 60px;
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px -4px 10px rgba(0, 10, 30, 0.1);
    z-index: calc(var(--level-subhigh) - 3);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;

    .closely-icon {
        display: flex;
        align-items: center;

        .iconfont.icon-close-light {
            font-size: 16px;
            color: #a8a8a8;
            margin-right: 15px;
        }

        .app-name {
            color: #191919;
            font-size: 16px;
            line-height: 20px;
            font-family: var(--font-medium);
            margin-left: 8px;
            white-space: nowrap;
        }

        img {
            width: 17px;
            height: 20px;
        }
    }

    .install-plugin {
        background: #3b6ef1;
        font-family: var(--font-bold);
        border-radius: 5px;
        display: block;
        color: #fff;
        line-height: 40px;
        font-size: 14px;
        padding: 0 20px;
    }
}
</style>
